import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SessionWithId } from '../Models/session';

interface sessionSliceState {
    selectedSession: SessionWithId | null;
}

const initialState: sessionSliceState = {
    selectedSession: null,
};

export const sessionsSlice = createSlice({
    name: 'sessions',
    initialState: initialState,
    reducers: {
        selectSession(
            state,
            action: PayloadAction<{ session: SessionWithId }>,
        ) {
            state.selectedSession = action.payload.session;
        },
        deselectSession(state) {
            state.selectedSession = null;
        },
    },
});

export const { selectSession, deselectSession } = sessionsSlice.actions;
